import { useMemo } from 'react';

const findDocumentByGroup = ({
  documents, type, group, klass,
}) => {
  const defaultDocument = {
    documentType: type,
    documentGrouping: group,
    documentClass: klass,
    noFiles: true,
  };
  if (!documents) return defaultDocument;
  const matchTypeAndGroup = (document) => (
    document.documentType === type
    && document.documentGrouping === group
  );
  return documents
    .find(matchTypeAndGroup) || defaultDocument;
};

export const useFindDocumentByGroup = ({
  data, type, group, klass,
}) => {
  const activeRequisition = data?.activeRequisition || null;
  const documents = activeRequisition?.documents || null;

  const document = useMemo(
    () => findDocumentByGroup({
      documents, type, group, klass,
    }),
    [documents, type, group, klass],
  );

  return { document };
};
